<template>
  <button
    :id="channelUrl"
    :class="buttonClasses"
    :aria-label="`Open conversation with ${name}`"
    :aria-current="isActive ? 'page' : 'false'"
    data-channel-preview="true"
    @click="handleClick"
  >
    <div class="flex items-center gap-12">
      <Avatar :name="name" :imageUrl="avatarUrl" size="base" />
      <div class="min-w-0 flex-1">
        <div class="flex items-center justify-between gap-8">
          <p class="text-m1 font-medium truncate">{{ name }}</p>
          <span v-if="lastMessageAt" class="text-s text-grey-text-subdued whitespace-nowrap">{{ lastMessageAt }}</span>
        </div>
        <p class="text-s text-grey-text-subdued truncate">{{ lastMessage }}</p>
      </div>
      <Badge v-if="unreadCount > 0" class="mb-16 badge-large" :badgeContent="unreadCount" />
    </div>
  </button>
</template>

<script lang="ts">
import Avatar from '@/components/avatar/Avatar.vue';
import Badge from '@/components/badge/Badge.vue';

export default {
  name: 'ChannelListItem',
  components: {
    Avatar,
    Badge,
  },
  props: {
    channelUrl: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    avatarUrl: {
      type: String,
      default: '',
    },
    lastMessage: {
      type: String,
      default: '',
    },
    lastMessageAt: {
      type: String,
      default: '',
    },
    unreadCount: {
      type: Number,
      default: 0,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonClasses(): string {
      return `channel-list-item w-full p-16 bg-white ${this.isActive ? 'is-active' : ''}`;
    },
  },
  methods: {
    handleClick() {
      this.$emit('select', this.channelUrl);
    },
  },
};
</script>

<style scoped lang="scss">
button.channel-list-item {
  box-sizing: border-box;
  text-align: left;
  position: relative;
  border-radius: 4px;
  outline: none;
  border: none;
  background-color: theme('colors.white');
  cursor: pointer;
  width: 100%;

  &:focus-visible {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border: 2px dotted theme('colors.grey.body');
      border-radius: 4px;
      pointer-events: none;
    }
  }

  &.is-active {
    background-color: theme('colors.grey.background.contrast');
  }
}
</style>
